import { Link } from "react-router-dom";
import { Phone, CalendarCheck } from "lucide-react";
import { FIRM } from "@/lib/site";

export default function CallNowBar() {
  return (
    <div
      data-testid="mobile-call-now-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 gap-px bg-navy-900/10 border-t border-navy-900/10 shadow-[0_-8px_30px_-12px_rgba(10,25,47,0.35)]"
    >
      <a
        href={`tel:${FIRM.phoneHref}`}
        data-testid="mobile-call-now-button"
        className="flex items-center justify-center gap-2 bg-navy-900 text-white py-4 text-sm font-semibold tracking-wide active:bg-navy-800"
      >
        <Phone className="h-4 w-4 text-gold" />
        Call Now
      </a>
      <Link
        to="/contact"
        data-testid="mobile-free-consult-button"
        className="flex items-center justify-center gap-2 bg-gold text-navy-950 py-4 text-sm font-semibold tracking-wide active:bg-gold/90"
      >
        <CalendarCheck className="h-4 w-4" />
        Free Consultation
      </Link>
    </div>
  );
}
